module.exports = __WEBPACK_EXTERNAL_MODULE_90__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/ui/Mouse","root":["openfl","ui","Mouse"],"commonjs":"openfl/ui/Mouse","commonjs2":"openfl/ui/Mouse"}
// module id = 90
// module chunks = 0